module.exports = __webpack_public_path__ + "img/sponsor5.0712d94d.png";